export default [
  {
    path: '/lesson_exchange',
    name: 'lesson_exchange',
    component: () => import('@/views/page/lesson_exchange.vue'),
    meta: {
      title: '课程兑换'
    }
  },
  {
    path: '/exchange_history',
    name: 'lesson_exchange.history',
    component: () => import('@/views/page/lesson_exchange_history.vue'),
    meta: {
      title: '兑换记录'
    }
  }
]
